module.exports = __webpack_public_path__ + "static/img/irole.cfc08ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/ch/irole.png
// module id = crCT
// module chunks = 7